import { createContext } from "react";
import type { IStudioEventConsumer } from "../../studio-event-emitter";

export interface StudioEventEmitterContextValue {
    /**
     * ID of the block.
     */
    id: string;
    /**
     * Won't be provided in platform, hence eventEmitter value is optional.
     * Consumers should check against falsy value before using it.
     */
    emitter?: IStudioEventConsumer;
}

export const StudioEventEmitterContext = createContext<StudioEventEmitterContextValue | null>(null);
